import { Component, inject } from '@angular/core';
import { SpinnerService } from './services/spinner-service';

@Component({
  selector: 'app-spinner',
  imports: [],
  templateUrl: './spinner.html',
  styleUrl: './spinner.css',
})
export class Spinner {
  public spinnerService = inject(SpinnerService);
}
